/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCall16(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      fill='none'
      viewBox='0 0 16 16'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M4.877 10.743a16.758 16.758 0 006.825 4.227 1.648 1.648 0 001.818-.711c.593-.917 1.35-2.145 1.35-2.145l-3.263-2.609-1.529 1.391a10.115 10.115 0 01-2.6-1.93l-.605-.619A9.956 9.956 0 015.04 5.722L6.569 4.33 4.073 1.025 1.761 2.176C1.105 2.504.753 3.215.905 3.915a16.266 16.266 0 003.972 6.828z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M9.248.75c3.04 0 5.5 2.462 5.5 5.5v.25M8.998 3.75a3 3 0 013 3'
      />
    </svg>
  );
}

export default SvgCall16;
